import React, { useState, useEffect } from 'react';
import './Gallery.css';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [loaded, setLoaded] = useState(false);
  
  // Sample gallery images - replace with your actual images
  const galleryImages = [
    { id: 1, src: '/images/gallery/image1.jpg', alt: 'Anmol and Mubeen at the beach' },
    { id: 2, src: '/images/gallery/image2.jpg', alt: 'Couple hiking in mountains' },
    { id: 3, src: '/images/gallery/image3.jpg', alt: 'Romantic dinner date' },
    { id: 4, src: '/images/gallery/image4.jpg', alt: 'Holiday celebration' },
    { id: 5, src: '/images/gallery/image5.jpg', alt: 'Family gathering' },
    { id: 6, src: '/images/gallery/image6.jpg', alt: 'Engagement photoshoot' },
    { id: 7, src: '/images/gallery/image7.jpg', alt: 'Weekend getaway' },
    { id: 8, src: '/images/gallery/image8.jpg', alt: 'Couple dancing' },
    { id: 9, src: '/images/gallery/image9.jpg', alt: 'Sunset silhouette' },
  ];
  
  useEffect(() => {
    setLoaded(true);
  }, []);
  
  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };
  
  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };
  
  return (
    <div className="page-container gallery-container">
      <h1>Our Gallery</h1>
      <p className="gallery-intro">
        A collection of our favorite moments together. We can't wait to create more memories with you on our special day.
      </p>
      
      <div className={`gallery-grid ${loaded ? 'loaded' : ''}`}>
        {galleryImages.map((image, index) => (
          <div 
            className="gallery-item" 
            key={image.id}
            style={{ animationDelay: `${index * 0.1}s` }}
            onClick={() => openLightbox(image)}
          >
            <img src={image.src} alt={image.alt} />
          </div>
        ))}
      </div>
      
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage.src} alt={selectedImage.alt} />
            <button className="close-button" onClick={closeLightbox}>×</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery; 